import { render, staticRenderFns } from "./reset-phone-numbers.vue?vue&type=template&id=43d7c20a&"
import script from "./reset-phone-numbers.vue?vue&type=script&lang=js&"
export * from "./reset-phone-numbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports